import React, { useState } from "react";
import useRoles from "../../hooks/useRoles";
import { Tabs, Tab } from "react-bootstrap";
import PrinterAccordion from "./PrinterAccordion";
import SupplyListTab from "./SupplyListTab";
import ScannerTab from "./ScannerTab";

/**
 * Корневой контейнер: хранит общие настройки принтера и переключает вкладки.
 * Печать через print-сервер вынесена сюда, чтобы переиспользовать в разных табах.
 */
const PackagingPage = () => {
  const { hasRole } = useRoles();

  // tabs: list | scanner
  const [activeUiTab, setActiveUiTab] = useState("list");
  // marketplace: wb | ozon | sorting_wb
  const [service, setService] = useState("wb");
  // режим интерфейса: normal | packing
  const [mode, setMode] = useState(localStorage.getItem("pack_mode") || "normal");

  // printer settings (shared for both tabs)
  const [printerIp, setPrinterIp] = useState(localStorage.getItem("printerIp") || "");
  const [printerName, setPrinterName] = useState(localStorage.getItem("printerName") || "");
  const [accordionOpen, setAccordionOpen] = useState(false);

  const handleSavePrinterSettings = () => {
    localStorage.setItem("printerIp", printerIp);
    localStorage.setItem("printerName", printerName);
    const encodedPrinterName = encodeURIComponent(printerName);
    window.open(`https://${printerIp}:4646/Print?printerName=${encodedPrinterName}`, "_blank");
  };

  const handlePrintFromPrintServerTest = async () => {
    const ip = localStorage.getItem("printerIp");
    const name = localStorage.getItem("printerName");
    if (!ip || !name) throw new Error("IP или имя принтера не указаны");

    const resp = await fetch(`https://${ip}:4646/Print`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ printerName: name, content: "iVBOR" }),
    });
    if (!resp.ok) throw new Error("Ошибка при отправке запроса к серверу печати");
  };

  // универсальная печать через print-сервер: принимает base64
  const printViaPrintServerBase64 = async (base64) => {
    const ip = localStorage.getItem("printerIp");
    const name = localStorage.getItem("printerName");
    if (!ip || !name) throw new Error("IP или имя принтера не указаны");

    const resp = await fetch(`https://${ip}:4646/Print`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ printerName: name, content: base64 }),
    });
    if (!resp.ok) throw new Error("Ошибка при отправке запроса к серверу печати");
  };

  const switchMode = (next) => {
    setMode(next);
    localStorage.setItem("pack_mode", next);
  };

  return (
    <div>
      <Tabs
        id="packing-tabs"
        activeKey={activeUiTab}
        onSelect={(k) => setActiveUiTab(k)}
        className="mb-3"
      >
        <Tab eventKey="list" title="Список по поставкам">
          <SupplyListTab
            mode={mode}
            onChangeMode={switchMode}
            service={service}
            onChangeService={setService}
            // printer ui — в режиме упаковки скрываем
            printerAccordion={
              mode !== "packing" && (
                <PrinterAccordion
                  accordionOpen={accordionOpen}
                  setAccordionOpen={setAccordionOpen}
                  printerIp={printerIp}
                  setPrinterIp={setPrinterIp}
                  printerName={printerName}
                  setPrinterName={setPrinterName}
                  onSavePrinterSettings={handleSavePrinterSettings}
                  onTestPrint={handlePrintFromPrintServerTest}
                />
              )
            }
            printViaPrintServerBase64={printViaPrintServerBase64}
          />
        </Tab>

        {hasRole('ScanQrCode') && (
          <Tab eventKey="scanner" title="Сканер">
            <ScannerTab
              hasRole={hasRole}
              printerAccordion={
                <PrinterAccordion
                  accordionOpen={accordionOpen}
                  setAccordionOpen={setAccordionOpen}
                  printerIp={printerIp}
                  setPrinterIp={setPrinterIp}
                  printerName={printerName}
                  setPrinterName={setPrinterName}
                  onSavePrinterSettings={handleSavePrinterSettings}
                  onTestPrint={handlePrintFromPrintServerTest}
                />
              }
            />
          </Tab>
        )}

      </Tabs>
    </div>
  );
};

export default PackagingPage;
